module.exports = __webpack_public_path__ + "static/banner-thumb-cff40409d94428b8db41ed012d8ea761.png";